import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  logo: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  lock: { display: 'flex', margin: 'auto', marginTop: '50px', marginBottom: '25px' },
  resetPassword: { marginTop: '5vh' },
  headingBox: { textAlign: 'center' },
}));

const Banner = () => {
  const classes = useStyles();

  return (
    <div className={classes.headingBox}>
      <img src={'/logo-light-stacked.svg'} alt="Trustate Logo" className={classes.logo} />
      <img src={'/lock.svg'} alt="Trustate Lock" className={classes.lock} />
      <div className={classes.resetPassword}>
        <Typography variant="h4" style={{ marginBottom: '15px' }}>
          Reset your password
        </Typography>
        <Typography style={{ display: 'inline', paddingLeft: '10px', paddingRight: '10px' }}>
          Create a password that you haven't used before.
        </Typography>
      </div>
    </div>
  );
};

export default Banner;
